import { Link } from "react-router-dom";
import { rupiah } from "@/lib/format";
import { Truck, Flame, Coins, TreePine } from "lucide-react";

export const rit = (v) => `${Number(v || 0).toLocaleString("id-ID", { maximumFractionDigits: 3 })} rit`;

const Cell = ({ icon: Icon, label, value, tone, testid }) => (
  <div className="card-flat p-4" data-testid={testid}>
    <div className="flex items-center justify-between">
      <div className="text-[11px] uppercase tracking-widest text-slate-500">{label}</div>
      <Icon size={15} className={tone}/>
    </div>
    <div className="mt-2 font-mono text-lg md:text-xl text-slate-900 tabular-nums">{value}</div>
  </div>
);

export const StokKayuBar = ({ stok, linkable = false }) => {
  const cells = [
    { icon: TreePine, label: "Sisa Stok Kayu", value: rit(stok?.sisa_rit), tone: "text-emerald-600", testid: "stok-kayu-sisa", to: "/produksi/kayu" },
    { icon: Coins, label: "Harga Rata-rata / Rit", value: rupiah(stok?.harga_rata_per_rit), tone: "text-amber-600", testid: "stok-kayu-avg", to: "/produksi/kayu" },
    { icon: Truck, label: "Nilai Stok Kayu", value: rupiah(stok?.nilai_sisa), tone: "text-slate-600", testid: "stok-kayu-nilai", to: "/produksi/kayu" },
    { icon: Flame, label: "Tungku Sedang Dibakar", value: `${stok?.batch_dibakar || 0} batch`, tone: "text-orange-600", testid: "stok-kayu-dibakar", to: "/produksi/bakar" },
  ];
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5" data-testid="stok-kayu-bar">
      {cells.map((c) => linkable
        ? <Link key={c.testid} to={c.to} className="block hover:opacity-90 transition-opacity"><Cell {...c}/></Link>
        : <Cell key={c.testid} {...c}/>)}
    </div>
  );
};
